var map = {
	"./agree/app.ts": 1762,
	"./auth/app.ts": 8952,
	"./contract/app.ts": 3315,
	"./face-auth/app.ts": 7099,
	"./home/app.ts": 4044,
	"./income/app.ts": 9132,
	"./tax-auth/app.ts": 9865,
	"./test/app.ts": 2972
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8503;